import { Language, UserDto, UserRole } from './user.dto';

export class User {
    readonly id: string;
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly role: UserRole;
    readonly isActive: boolean;
    readonly confirmed: boolean;
    readonly confirmedAt: Date | null;
    readonly lastActiveAt: Date | null;
    readonly createdAt: Date;
    readonly language: Language;

    constructor(data: UserDto) {
        this.id = data.id;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.role = data.role;
        this.isActive = data.isActive;
        this.confirmed = data.confirmed;
        this.confirmedAt = data.confirmedAt ? new Date(data.confirmedAt) : null;
        this.lastActiveAt = data.lastActiveAt ? new Date(data.lastActiveAt) : null;
        this.createdAt = new Date(data.createdAt);
        this.language = data.language;
    }
}
